import CourseStatsModel from "./course-stats-model";

export default class CourseStats {
    constructor() {
        this.$root = document.getElementById('courseStats');
        this.$courseStatsInfo = document.getElementById('courseStatsInfo');
        this.$courseStatsPrice = document.getElementById('courseStatsPrice');
        this.$courseStatsPriceParts = document.getElementById('courseStatsPriceParts');
        this.$courseStatsFullPriceValue = document.getElementById('courseStatsFullPriceValue');
        this.$courseStatsUpfrontDiscount = document.getElementById('courseStatsUpfrontDiscount');
        this.$courseStatsUpfrontDiscountValue = document.getElementById('courseStatsUpfrontDiscountValue');
        this.$courseStatsFinalPriceValue = document.getElementById('courseStatsFinalPriceValue');
        this.$courseStatsStartDate = document.getElementById('courseStatsStartDate');
        this.$courseStatsPeoplePerWeek = document.getElementById('courseStatsPeoplePerWeek');
        this.$courseStatsPeoplePerWeekLabel = document.getElementById('courseStatsPeoplePerWeekLabel');
        this.$courseStatsPeoplePerWeekValue = document.getElementById('courseStatsPeoplePerWeekValue');
        this.$courseStatsPlacesLeft = document.getElementById('courseStatsPlacesLeft');
        this.$courseStatsPlacesLeftValue = document.getElementById('courseStatsPlacesLeftValue');

        this.model = new CourseStatsModel();

        this.init();
    }

    init() {
        this.model.fetch(() => {
            this.setAll();
            this.$root.classList.remove('-loading');
        })
    }

    setAll() {
        this.setStartDate();
        this.setPeoplePerWeek();
        this.setPlacesLeft();
        // this.setPrice();
    }

    setStartDate() {
        if (!this.model.startDateText || !this.$courseStatsStartDate) {
            return;
        }

        this.$courseStatsStartDate.dateTime = this.model.startDate;
        this.$courseStatsStartDate.textContent = this.model.startDateText;
    }

    setPeoplePerWeek() {
        if (!this.model.peoplePerWeekText) {
            this.$courseStatsPeoplePerWeek.remove();
            return;
        }

        this.$courseStatsPeoplePerWeekLabel.textContent = this.model.peoplePerWeekText.label;
        this.$courseStatsPeoplePerWeekValue.textContent = this.model.peoplePerWeekText.value;
    }

    setPlacesLeft() {
        if (!this.model.placesLeftText) {
            this.$courseStatsPlacesLeft.remove();
            return;
        }


        this.$courseStatsPlacesLeftValue.textContent = this.model.placesLeftText;
    }

    setPrice() {
        if (!this.model.pricePartsText || !this.$courseStatsPrice) {
            if (this.$courseStatsPrice) {
                this.$courseStatsPrice.remove();
            }

            this.$courseStatsInfo.classList.add('-center');
            return;
        }

        this.$courseStatsPriceParts.textContent = this.model.pricePartsText;

        this.setFullPrice();
        this.setUpfrontDiscount();
        this.setFinalPrice();
    }

    setFullPrice() {
        if (!this.model.fullPriceText) {
            return;
        }

        this.$courseStatsFullPriceValue.textContent = this.model.fullPriceText;
    }

    setUpfrontDiscount() {
        if (!this.model.upfrontDiscountText) {
            this.$courseStatsUpfrontDiscount.remove();
            return;
        }

        this.$courseStatsUpfrontDiscountValue.textContent = this.model.upfrontDiscountText;
    }

    setFinalPrice() {
        if (!this.model.finalPriceText) {
            return;
        }

        this.$courseStatsFinalPriceValue.textContent = this.model.finalPriceText;
    }
}